"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _tooltip = _interopRequireDefault(require("@remote-com/norma/core/tooltip"));

var _uploadCircle = _interopRequireDefault(require("../../../../public/images/upload-circle.svg"));

var _general = require("../../../helpers/general");

var _FileField = require("./FileField.styled");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var FileUpload = function FileUpload(_ref) {
  var label = _ref.label,
      files = _ref.files,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      onFilesSelected = _ref.onFilesSelected,
      onFilesRemoved = _ref.onFilesRemoved,
      dataTestid = _ref['data-testid'],
      ariaLabel = _ref['aria-label'];

  var _useState = (0, _react.useState)(files),
      filesList = _useState[0],
      setFilesList = _useState[1];

  var hasFiles = filesList.length > 0;
  var removeFilesLabel = (0, _general.getSingularOrPlural)(filesList.length, 'Remove selected file', 'Remove selected files');

  function handleReset() {
    onFilesRemoved(filesList);
    setFilesList([]);
  }

  function handleClick(event) {
    if (hasFiles) {
      event.preventDefault();
      event.target.value = null;
      handleReset();
    }
  }

  var handleFileChange = function handleFileChange(event) {
    var selectedFiles = event.target.files;
    setFilesList((0, _toConsumableArray2["default"])(selectedFiles));
    onFilesSelected((0, _toConsumableArray2["default"])(selectedFiles));
  };

  return __jsx(_FileField.FileContainer, {
    $hasFiles: hasFiles
  }, __jsx(_FileField.FileInput, {
    as: "input",
    type: "file",
    multiple: multiple,
    "data-testid": "".concat(dataTestid, "-input"),
    onChange: function onChange(event) {
      event.persist();
      handleFileChange(event.nativeEvent);
    },
    onClick: handleClick,
    "aria-label": ariaLabel
  }), hasFiles ? __jsx(_tooltip["default"], {
    label: removeFilesLabel,
    autoWidth: true
  }, __jsx(_FileField.FileRemove, {
    "aria-label": removeFilesLabel
  })) : __jsx(_FileField.FileButton, null, __jsx(_FileField.FileHandle, null, __jsx(_uploadCircle["default"], null)), __jsx(_FileField.FileLabel, null, __jsx(_FileField.FileLabelTitle, null, label))));
};

FileUpload.defaultProps = {
  label: 'Upload here',
  files: [],
  'data-testid': 'fileUpload'
};
var _default = FileUpload;
exports["default"] = _default;